<script>
  import marked from 'marked';

  export let markdownValue;
  $: markdownHTML = marked(markdownValue);

  
</script>
  
  <div class="markdown-app__preview-col">
    <div class="markdown-app__preview-output">
      {@html markdownHTML}
    </div>
  </div>
  
  <style>
    .markdown-app__preview-col {
      grid-column: 2;
      padding: 15px 20px 0;
    }
  </style>